import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import SequencerOperationLog from "models/audioEditor/sequencerOperationLog/SequencerOperationLog";
import RSVP from "rsvp";

const SequencerOperationCreateNewSpeakerAndAssignToSequencerNodesOperationLog =  SequencerOperationLog.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        SequencerOperationLog.apply(this, [attributes, options]);
        
    },

    getOperationName : function(){
        return "Create New Speaker And Assign";
    },
    
    setSequencerNodeCidArray : function(sequencerNodeCidArray){
        this.set("sequencerNodeCidArray", sequencerNodeCidArray);
    },

    getSequencerNodeCidArray : function(){
        return this.get("sequencerNodeCidArray");
    },

    setSpeakerLabel : function(speakerLabel){
        this.set("speakerLabel", speakerLabel);
    },

    getSpeakerLabel : function(){
        return this.get("speakerLabel");
    },

    setSequencerNodeCidToOldSpeakerId : function(sequencerNodeCidToOldSpeakerId){
        this.set("sequencerNodeCidToOldSpeakerId", sequencerNodeCidToOldSpeakerId);
    },

    getSequencerNodeCidToOldSpeakerId : function(){
        return this.get("sequencerNodeCidToOldSpeakerId");
    },

    setNewSpeakerWasAdded : function(newSpeakerWasAdded){
        this.set("newSpeakerWasAdded", newSpeakerWasAdded);
    },

    getNewSpeakerWasAdded : function(){
        return this.get("newSpeakerWasAdded");
    },

    setNewSpeakerInfo : function(newSpeakerInfo){
        this.set("newSpeakerInfo", newSpeakerInfo);
    },

    getNewSpeakerInfo : function(){
        return this.get("newSpeakerInfo");
    },





});

export default SequencerOperationCreateNewSpeakerAndAssignToSequencerNodesOperationLog;
